import React from "react";
import { Container } from "../forms/controls";

const WarningText = ({ children }: { children: React.ReactNode }) => (
    <Container cssClass={"warning-text"} >
        <div>
            <span>Warning: {children}</span>
        </div>
    </Container>
);

export { WarningText };
